import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { Subscription } from './types/Subscriptions';

interface Payload {
  paymentMethodId?: number;
  stripePaymentMethodId?: string;
  paymentIntentReference?: string;
  currency: string;
  priceCodes: string[];
  couponId?: string;
  billingCountry?: string;
  customerName?: string;
}

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Subscription>('POST', `${APIV2_URL}/billing/subscription`, {
    data,
  });
